var _path, _path2, _path3, _path4, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 8V9.88872C4.94349 10.2953 4.75845 10.6753 4.45402 10.946C4.14958 11.2166 3.75047 11.3559 3.34375 11.3333H0.90625",
    stroke: "currentcolor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.90625 10.1146V12.1458",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14908 6.82356L1.08574 4.93095C0.98167 4.90306 0.892937 4.83497 0.839065 4.74166C0.785193 4.64835 0.770594 4.53747 0.798481 4.43339L1.32421 2.47136C1.49152 1.84692 1.90005 1.31452 2.4599 0.991291C3.01976 0.668059 3.68508 0.580467 4.30952 0.747784L12.9425 3.06098C13.1506 3.11675 13.3281 3.25293 13.4358 3.43954C13.5436 3.62616 13.5728 3.84794 13.517 4.05608L13.3383 4.72318C13.2976 4.87503 13.2137 5.01183 13.0969 5.11698C12.98 5.22213 12.8352 5.29112 12.6799 5.31559L9.24919 5.85715L9.14418 6.24904C9.08841 6.45718 8.95223 6.63465 8.76562 6.74239C8.579 6.85014 8.35722 6.87933 8.14908 6.82356Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4449 5.51067L10.6856 8.34437C10.6299 8.55252 10.4937 8.72998 10.3071 8.83773C10.1205 8.94547 9.89869 8.97467 9.69054 8.9189L2.62721 7.02628C2.21092 6.91474 1.85599 6.64239 1.6405 6.26915C1.42501 5.89592 1.36662 5.45236 1.47816 5.03607",
    fill: "currentcolor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.662,
    y: 5.87076,
    width: 1.6104,
    height: 2.55774,
    rx: 0.25,
    transform: "rotate(15 11.662 5.87076)",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitor-icon.ebf8d1505d3efd407e5f9043bc3efef8.svg";
export { ForwardRef as ReactComponent };